import { render, staticRenderFns } from "./ViewInvoice.vue?vue&type=template&id=5a5f2e4a&scoped=true&"
import script from "./ViewInvoice.vue?vue&type=script&lang=js&"
export * from "./ViewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ViewInvoice.vue?vue&type=style&index=0&id=5a5f2e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5f2e4a",
  null
  
)

export default component.exports